<template>
  <div>
    <span v-if="dataValue.value < 0" class="avail-error">{{ dataValue.text }}</span>
    <span v-if="dataValue.value > 0">{{ dataValue.text }}</span>
    <span v-if="dataValue.value == 0">{{ "-" }}</span>
  </div>
</template>

<script>
export default {
  props: {
    dataValue: {
      type: [Object, Array],
    },
  },
};
</script>

<style lang="scss">
</style>
